import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";

import { Box, Text } from "~/components/blocks";

const Root = styled("div")(({ theme }) =>
  css({
    background: theme.colors.background.lightGreen,
    margin: "0",
    padding: theme.space.l,
  }),
);

const Question = styled("dl")(({ theme }) =>
  css({
    marginTop: theme.space.m,
  }),
);

const Subject = styled("dt")(({ theme }) =>
  css({
    fontSize: theme.fontSizes.m,
    fontWeight: theme.fontWeights.bold,
    "&::before": {
      color: theme.colors.text.primary,
      content: '"Q"',
      paddingRight: theme.space.m,
    },
  }),
);

const Wrap = styled(Box)(({ theme }) =>
  css({
    width: "100%",
    maxWidth: theme.windowSize.base,
    margin: "0 auto",
    padding: "0",
    boxSizing: "border-box",
    [`@media ${theme.mediaQueries.sp}`]: {
      margin: `0 auto`,
    },
  }),
);

const Answer = styled("dd")(({ theme }) =>
  css({
    position: "relative",
    marginTop: theme.space.s,
    fontSize: theme.fontSizes.s,
    paddingLeft: `calc(${theme.space.l} + ${theme.space.s})`,
    "&::before": {
      color: theme.colors.colorPallete.lightGrey,
      content: '"A"',
      fontSize: theme.fontSizes.m,
      fontWeight: theme.fontWeights.bold,
      height: "100%",
      left: "1px",
      paddingRight: theme.space.m,
      position: "absolute",
    },
  }),
);

export const Questions = () => {
  return (
    <Root>
      <Wrap>
        <Text fontWeight="bold" size="l">
          よくある質問
        </Text>
        <Question>
          <Subject>希望した日時を過ぎても通知が届きません</Subject>
          <Answer>
            登録した携帯電話番号が間違っている可能性やお薬の準備が遅れていることが考えられます。お手数ですが、薬局まで直接お電話にてご確認ください
          </Answer>
        </Question>
        <Question>
          <Subject>キャンセルはできますか？</Subject>
          <Answer>
            キャンセルを希望される場合は、確認メッセージに記載されているURLからの手続き、もしくは薬局に直接お電話にてご連絡ください
          </Answer>
        </Question>
      </Wrap>
    </Root>
  );
};
